
























































import { Component, Vue, Prop } from 'vue-property-decorator';
import BackgroundCheck from '~/components/UIComponents/BackgroundCheck.vue';

@Component({ components: { BackgroundCheck } })
export default class BlueHeroBanner extends Vue {
  @Prop({ type: Boolean, default: false }) readonly padded!: boolean;
  @Prop({ type: Boolean, default: true }) readonly stack!: boolean;
  @Prop({ type: Boolean, default: false }) readonly reverse!: boolean;
  @Prop({ type: Boolean, default: false }) readonly flipped!: boolean;
  @Prop({ type: Boolean, default: false }) readonly short!: boolean;
  @Prop({ type: Number, default: 10 }) readonly checkOffset!: number;

  get stacked() {
    return this.$vuetify.breakpoint.xs && this.stack;
  }
  get reversed() {
    return this.$vuetify.breakpoint.xs && this.stack && this.reverse;
  }

  get placeholderStyle() {
    let percentage =
      this.stacked && this.short
        ? '18%'
        : this.short
        ? '55%'
        : this.stacked
        ? '90%'
        : this.$vuetify.breakpoint.lgAndUp
        ? '100%'
        : '95%';

    return {
      paddingTop: `calc(${percentage}/ 1.25)`,
    };
  }
}
